module.exports = __webpack_public_path__ + "static/assets/yeswecancan.e3cf05b8.jpg";